import type { AxiosInstance } from 'axios'
import { useAuthStore } from '@/stores/auth'
import { getTimezoneName, getTimezoneOffsetMinutes } from '@/lib/utils/timezone'
import { toApiError } from '@/lib/api/errors'

export function registerInterceptors(instance: AxiosInstance): void {
  instance.interceptors.request.use((config) => {
    const auth = useAuthStore()

    if (auth.token) {
      config.headers.set('Authorization', `Bearer ${auth.token}`)
      config.headers.set('X-Timezone', getTimezoneName())
      config.headers.set('X-Timezone-Offset-Minutes', String(getTimezoneOffsetMinutes()))
    }

    return config
  })

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const apiError = toApiError(error)

      if (apiError.status === 401) {
        useAuthStore().logout()
      }

      return Promise.reject(apiError)
    },
  )
}
